import { render, staticRenderFns } from "./Withholdings.vue?vue&type=template&id=5d11733e"
import script from "./Withholdings.vue?vue&type=script&lang=js"
export * from "./Withholdings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports